import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledDropdown,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getallAcessGroup } from "store/accessgroupsetting/action"
import { Access, GroupName } from "./accessgroupcols"
import TableContainer from "components/Common/TableContainer"
import AccessGroupForm from "./accessgroupForm"

const Access_Group_Setting = props => {
  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [selectedRow, setselectedRow] = useState({})
  const [pageSize, setpageSize] = useState(10)
  const [pageindex, setpageindex] = useState(0)
  // Handle API Call
  const companyid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data
    ?.companysetting?.companyid
  const userid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id
  const accessgroupname = JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.accessgroupname;

  const params = {
    // categoryId:null,
    companyid: companyid,
    userId: userid,
    pageNumber: 1,
    pageSize: pageSize,
  }

  useEffect(() => {
    dispatch(getallAcessGroup(params))
  }, [])
  const { accessgrouplist, updateAccessSuccess, companySetting, accessSetting } = useSelector(state => ({
    accessgrouplist: state?.accessgroup?.accessgrouplist,
    updateAccessSuccess: state?.accessgroup?.updateaccessgroup?.statusCode,
    companySetting: state?.Login?.userDetails?.data,
    accessSetting: state?.Login?.accessDetails?.data
  }))

  var hideaccessgroupsetting = accessSetting?.manageAccessGroup

  useEffect(() => {
    if (updateAccessSuccess === 200) {
      dispatch(getallAcessGroup())
    }
  }, [updateAccessSuccess])

  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Access Group Name",
        accessor: "accessGroupName",
        disableFilters: true,
        filterable: true,
        sort: true,
        minWidth: 90,
        width: 50,
        Cell: cellProps => {
          return <GroupName {...cellProps} />
        },
      },

      {
        Header: "Trac Screen Live View",
        accessor: "tracScreenLiveView",
        disableFilters: true,
        sort: false,
        minWidth: 80,
        width: 20,
        filterable: true,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "Report Restricted " + companySetting?.MainCategory,
        accessor: "reportRestrictedCategory",
        disableFilters: true,
        filterable: true,
        sort: false,
        minWidth: 120,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "Trac Screen View",
        accessor: "tracScreenView",
        disableFilters: true,
        filterable: true,
        sort: false,
        minWidth: 80,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "On Evaluation Hours Approval",
        accessor: "onEvaluationHrsApproval",
        disableFilters: true,
        filterable: true,
        sort: false,
        minWidth: 120,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "Trac Report",
        accessor: "tracReport",
        sort: false,
        disableFilters: true,
        minWidth: 50,
        width: 50,
        filterable: true,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "Trac Hours",
        accessor: "tracHrs",
        disableFilters: true,
        sort: false,
        minWidth: 50,
        width: 50,
        filterable: true,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "Create " + companySetting?.MainCategory,
        accessor: "createMainCat",
        disableFilters: true,
        sort: false,
        filterable: true,
        minWidth: 60,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "Create " + companySetting?.SubCategory,
        accessor: "createSubCat",
        disableFilters: true,
        filterable: true,
        minWidth: 90,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "Create Track Profile",
        accessor: "createTrackProfile",
        disableFilters: true,
        filterable: true,
        sort: false,
        minWidth: 90,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "Change Other User Hours",
        accessor: "changeOtherUserHrs",
        disableFilters: true,
        filterable: true,
        sort: false,
        minWidth: 100,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "Invite User",
        accessor: "inviteUser",
        disableFilters: true,
        sort: false,
        filterable: true,
        minWidth: 50,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "Create User",
        accessor: "createUser",
        disableFilters: true,
        sort: false,
        filterable: true,
        minWidth: 50,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "Block User",
        accessor: "blockUser",
        disableFilters: true,
        sort: false,
        filterable: true,
        minWidth: 50,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "Delete User Data",
        accessor: "deleteUserData",
        sort: false,
        disableFilters: true,
        filterable: true,
        minWidth: 70,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "Delete User Screen",
        accessor: "deleteUserScreen",
        sort: false,
        disableFilters: true,
        filterable: true,
        minWidth: 80,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "View All Report",
        accessor: "viewAllReport",
        disableFilters: true,
        sort: false,
        filterable: true,
        minWidth: 70,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "Access All Team",
        accessor: "accessAllTeam",
        disableFilters: true,
        filterable: true,
        sort: false,
        minWidth: 70,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "Create Team",
        accessor: "createTeam",
        disableFilters: true,
        filterable: true,
        sort: false,
        minWidth: 50,
        width: 50,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "Admin Reports",
        accessor: "adminReports",
        disableFilters: true,
        filterable: true,
        sort: false,
        minWidth: 50,
        width: 60,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },
      {
        Header: "Webhook",
        accessor: "webhook",
        disableFilters: true,
        filterable: true,
        sort: false,
        minWidth: 60,
        width: 70,
        Cell: cellProps => (
          <div style={{ textAlign: "center" }}>
            {" "}
            <Access {...cellProps} />{" "}
          </div>
        ),
      },

      {
        Header: "Action",
        sort: false,
        accessor: "hideeditButton",
        width: 50,
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div
              role="buttton"
              style={{ cursor: "Pointer", textAlign: "center" }}
            >
              <UncontrolledDropdown>
                <DropdownToggle href="#" className="card-drop" tag="i">
                  <i className="mdi mdi-dots-vertical font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    href="#"
                    onClick={e => {
                      handleaccessEditGroup(cellProps.row.original)
                    }}
                  >
                    Edit
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ]
    return result
  }, [])

  const handleCancel = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }

  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const handleUserClick = arg => {
    setIsEdit(false)
    toggle()
  }

  const handleaccessEditGroup = data => {
    if (data !== null) {
      setIsEdit(true)
      setselectedRow(data)
    } else {
      validation.resetForm()
      setIsEdit(false)
    }
    toggle()
  }
  const handlePageValue = value => {
    if (!value.noChange) setpageindex(value.pageNumber)
    setpageSize(value.pageSize)
    dispatch(
      getallAcessGroup({
        ...value,
        pageNumber: value.pageNumber + 1,
        companyid: companyid,
        userId: userid,
      })
    )
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs="12">
              <Breadcrumbs
                title={"Manage Access Group Setting"}
                breadcrumbItem={"Manage Access Group Setting"}
              />
              <Card>
                <CardBody>
                  <TableContainer
                    keyField="id"
                    data={accessgrouplist?.data || []}
                    columns={columns}
                    isGlobalFilter={false}
                    isAddAccessList={true}
                    customPageSize={10}
                    className="custom-header-css"
                    buttonName={"Create Access Group"}
                    handleUserClick={handleUserClick}
                    handleaccessEditGroup={handleaccessEditGroup}
                    handlePageValue={handlePageValue}
                    pageindex={pageindex}
                    setpageindex={setpageindex}
                    totalCount={accessgrouplist?.count || 0}
                    customPageSizeOptions
                    hidepagination={true}
                    accessgroupname={accessgroupname}
                    hideaccessgroupsetting={hideaccessgroupsetting}
                  />
                  <Modal isOpen={modal} toggle={toggle} size="lg">
                    <ModalHeader toggle={toggle} tag="h4">
                      {isEdit ? "Edit Access Group" : "Create Access Group"}
                    </ModalHeader>
                    <ModalBody>
                      <AccessGroupForm
                        isEdit={isEdit}
                        selectedRow={selectedRow}
                        handleCancel={handleCancel}
                        toggle={toggle}
                        companySetting={companySetting}
                      />
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Access_Group_Setting
